import api from "../../api";
import { hasActiveSession } from "../../../config/cookies";

export const requestChatbotSession = async (
  signal?: AbortSignal
) => {
  if (!hasActiveSession()) {
    throw new Error(
      "Sua sessão expirou. Entre novamente para acessar o ChatBot."
    );
  }

  const response = await api.get<string>("chatweb/permissions", {
    responseType: "text",
    signal,
  });

  const chatbotToken =
    typeof response.data === "string" ? response.data.trim() : "";

  if (!chatbotToken) {
    throw new Error("O backend não retornou uma sessão válida do ChatBot.");
  }

  return chatbotToken;
};
